import SmartPillLogData, { RenderStoryOptions } from '../store/schema/SmartPillLogData';

export default function initializeSmartPillLogData(
    type: string,
    loggableText: string,
    cosmosOnlyData?: string
): SmartPillLogData {
    return {
        mainPayload: {
            renderStory: RenderStoryOptions.Renderable,
            loggableText: loggableText,
            type: type,
            timeClicked: null,
            position: -1, // updated by framework on render
        },
        cosmosOnlyData: cosmosOnlyData,
    };
}
